<template>
  <div></div>
</template>

<script>
export default {
  name: "Request",
};
</script>

<style lang="scss" scoped>
</style>